var irreducible = require('./irreducible');
var isArray = require('./isArray');

module.exports = irreducible('Array', isArray);



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Array.js
// module id = 174
// module chunks = 0